import SkeletonBase from "@/components/skeletonBase";

const QuotationProcessSkeleton = () => {
  return (
    <div className="d-flex flex-column gap-3 mx-md-5 mx-2 qp-page">
      <SkeletonBase width="150px" height="30px" className="rounded" />

      <div className="qp-layout">
        <div className="qp-main">
          <div className="bg-white border rounded p-4 d-flex flex-column gap-3">
            <div className="d-flex gap-3">
              <SkeletonBase width="120px" height="24px" className="rounded-pill" />
              <SkeletonBase width="40px" height="24px" className="rounded-circle" />
            </div>
            <SkeletonBase width="60%" height="28px" className="rounded" />
            <SkeletonBase width="80%" height="20px" className="rounded" />
            <div className="d-flex gap-3 mt-2">
              <SkeletonBase width="200px" height="60px" className="rounded" />
              <SkeletonBase width="200px" height="60px" className="rounded" />
            </div>
          </div>

          <div className="bg-white border rounded p-4 d-flex flex-column gap-3">
            <SkeletonBase width="30%" height="24px" className="rounded" />
            <div className="d-flex flex-column gap-2 mt-3">
              <SkeletonBase width="100%" height="50px" className="rounded" />
              <SkeletonBase width="100%" height="50px" className="rounded" />
              <SkeletonBase width="100%" height="50px" className="rounded" />
            </div>
          </div>

          <div className="bg-white border rounded p-4 d-flex flex-column gap-3">
            <SkeletonBase width="30%" height="24px" className="rounded" />
            <div className="d-flex flex-column gap-3 mt-2">
              <SkeletonBase width="100%" height="70px" className="rounded" />
              <SkeletonBase width="100%" height="70px" className="rounded" />
              <SkeletonBase width="100%" height="70px" className="rounded" />
            </div>
          </div>
        </div>

        <div className="qs-sidebar">
          <div className="bg-white border rounded p-4 d-flex flex-column gap-3">
            <div className="d-flex align-items-center gap-2 mb-2">
              <SkeletonBase width="24px" height="24px" className="rounded-circle" />
              <SkeletonBase width="40%" height="20px" className="rounded" />
            </div>
            <div className="d-flex justify-content-between">
              <SkeletonBase width="40%" height="20px" className="rounded" />
              <SkeletonBase width="30%" height="20px" className="rounded" />
            </div>
            <div className="d-flex justify-content-between">
              <SkeletonBase width="40%" height="20px" className="rounded" />
              <SkeletonBase width="30%" height="20px" className="rounded" />
            </div>
            <hr className="my-1" />
            <div className="d-flex justify-content-between">
              <SkeletonBase width="50%" height="24px" className="rounded" />
              <SkeletonBase width="30%" height="24px" className="rounded" />
            </div>
            <SkeletonBase width="100%" height="65px" className="rounded mt-2" />
            <SkeletonBase width="100%" height="45px" className="rounded mt-1" />
          </div>

          <div className="bg-white border rounded p-4 d-flex flex-column gap-2">
            <SkeletonBase width="40%" height="20px" className="rounded mb-2" />
            <SkeletonBase width="100%" height="16px" className="rounded" />
            <SkeletonBase width="90%" height="16px" className="rounded" />
            <SkeletonBase width="60%" height="16px" className="rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationProcessSkeleton;